var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVolumeBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5962 13.5962L13.889 12.889C14.9279 11.8502 15.5 10.4691 15.5 9C15.5 7.53088 14.9279 6.14978 13.889 5.11096L14.5962 4.40381C15.8239 5.63153 16.5 7.26379 16.5 9C16.5 10.7362 15.8239 12.3685 14.5962 13.5962ZM17.0711 1.92889L16.364 2.63605C19.873 6.14514 19.873 11.8549 16.364 15.364L17.0711 16.0711C20.97 12.1721 20.97 5.82794 17.0711 1.92889ZM9.5 0.292908L3.79291 6H0V12H3.79291L9.5 17.7071V0.292908ZM1 7H4.20709L8.5 2.70709V15.2929L4.20709 11H1V7Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeBlack);
export default __webpack_public_path__ + "static/media/volume-black.5a55155512a1fa5b634758780bbb8ede.svg";
export { ForwardRef as ReactComponent };